import { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate, Link, useParams, useSearchParams } from "react-router-dom";
import AlertMessage from "../include/AlertMessage";
var _ = require('lodash');


function EditArtist() {
    const [searchParams] = useSearchParams();
    const page = searchParams.get("page") || 1;

    const [alert, setAlert] = useState({ type: "", message: "" });
    const [formData, setFormData] = useState({ firstName: '', lastName: '' });
    const [errors, setErrors] = useState({});
    const redirectHistory = useNavigate();
    const { id } = useParams();
    const token = sessionStorage.getItem('JWT_TOKEN');
    const [loading, setLoading] = useState(true);

    const validate = () => {
        const newErrors = {};
        if (!formData.firstName) newErrors.name = "First name is required.";
        if (!formData.lastName) newErrors.icon = "Last name is required.";
        return newErrors;
    };

    // Define an async function inside useEffect
    const fetchAristDetail = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/fetchArtistDetail/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });


            const resdata = response.data.data;
            const customdata = {
                firstName: resdata.firstName,
                lastName: resdata.lastName
            }
            setFormData(customdata); // Set data to state                
        } catch (error) {
            const apierror = _.get(error, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }
    };


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    useEffect(() => {
        document.documentElement.className = "";

        fetchAristDetail();
    }, [id]);

    const handleEdit = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            try {

                //API URL
                const response = await axios.put(`${process.env.REACT_APP_API_URL}/editartist/${id}`, {
                    "firstName": formData.firstName,
                    "lastName": formData.lastName
                },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    setAlert({ type: "success", message: "Artist updated successfully." });
                    setTimeout(() => {
                        redirectHistory(`/artists?page=${page}`);
                    }, 2500);
                }

            } catch (err) {
                const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Failed to edit artist. Please try again.");
                setAlert({ type: "error", message: apierror });
            }

        }
    }

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/categories" className='btn btn-primary'>Artists</Link></li>
                        <li>Edit Artist</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Edit Artist
                            </p>
                        </header>
                        <div className="card-content">
                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (
                                <form onSubmit={handleEdit}>
                                    {alert.message && (
                                        <AlertMessage
                                            type={alert.type}
                                            message={alert.message}
                                            onClose={() => setAlert({ type: "", message: "" })}
                                        />
                                    )}
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label" htmlFor="firstName">First Name <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" name="firstName" id="firstName" type="text" placeholder="First Name" value={formData.firstName} onChange={handleChange} />
                                            </div>
                                            {errors.firstName && <p className="help" style={{ color: 'red' }}>{errors.firstName}</p>}
                                        </div>
                                        <div className="field">
                                            <label className="label" htmlFor="lastName">Last Name <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" name="lastName" id="lastName" type="text" placeholder="Last Name" value={formData.lastName} onChange={handleChange} />
                                            </div>
                                            {errors.lastName && <p className="help" style={{ color: 'red' }}>{errors.lastName}</p>}
                                        </div>
                                    </div>
                                    <div className="flex justify-center items-center">
                                        <div className="field grouped">
                                            <div className="control">
                                                <button type="submit" className="button green">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default EditArtist;
